import { render } from "./Problem.vue?vue&type=template&id=62435252&scoped=true&ts=true"
import script from "./Problem.vue?vue&type=script&lang=ts"
export * from "./Problem.vue?vue&type=script&lang=ts"

import "./Problem.vue?vue&type=style&index=0&id=62435252&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62435252"]])

export default __exports__